{
  "identities.messages.1010001": "ننوتل",
  "identities.messages.1010002": "د {provider} سره ننوتل",
  "identities.messages.1010003": "مهرباني وکړئ د دې تصدیق کولو سره چې دا تاسو یاست دا عمل تایید کړئ.",
  "identities.messages.1010004": "مهرباني وکړئ دوهم تصدیقي چیلنج بشپړ کړئ.",
  "identities.messages.1010005": "تصدیق",
  "identities.messages.1010006": "تصدیقي کوډ",
  "identities.messages.1010007": "د بیک اپ بیارغونې کوډ",
  "identities.messages.1010008": "د هارډویر کیلي سره دوام ورکړئ",
  "identities.messages.1010009": "دوام ورکړئ",
  "identities.messages.1010010": "دوام ورکړئ",
  "identities.messages.1010011": "د هارډویر کیلي سره ننوتل",
  "identities.messages.1010012": "خپل WebAuthn وسیله (د بیلګې په توګه امنیتي کیلي، بایومیټریک سکینر، ...) چمتو کړئ او دوام ورکړئ.",
  "identities.messages.1010013": "دوام ورکړئ",
  "identities.messages.1010014": "تاسو ته چې چمتو کړې ادرس ته یوه کوډ واستول شوه. که چیرې تاسو دا نه وو ترلاسه کړې، مهرباني وکړئ د ادرس سپیلنګ وګورئ او بیا هڅه وکړئ.",
  "identities.messages.1010015": "د ننوتلو کوډ واستوئ",
  "identities.messages.1010016": "تاسو د \"{duplicateIdentifier}\" سره د ننوتلو هڅه وکړه، مګر دا بریښنالیک لا دمخه د بل حساب لخوا کارول کیږي. خپل حساب ته د لاندې اختیارونو څخه یو سره ننوځئ ترڅو خپل حساب \"{duplicateIdentifier}\" په \"{provider}\" کې د ننوتلو بله لاره په توګه اضافه کړئ.",
  "identities.messages.1010017": "ننوتل او ونښلول",
  "identities.messages.1010018": "د {provider} سره تایید",
  "identities.messages.1010019": "د دوام لپاره کوډ غوښتنه وکړئ",
  "identities.messages.1010021": "د پاسکي سره ننوتل",
  "identities.messages.1010022": "د پټنوم سره ننوتل",
  "identities.messages.1010023": "کوډ {address} ته واستوئ",
  "identities.messages.1040001": "نوم لیکنه",
  "identities.messages.1040002": "د {provider} سره نوم لیکنه",
  "identities.messages.1040003": "دوام ورکړئ",
  "identities.messages.1040004": "د امنیتي کیلي سره نوم لیکنه",
  "identities.messages.1040005": "تاسو ته چې چمتو کړې ادرس (ونو) ته یوه کوډ واستول شوه. که تاسو پیغام نه وو ترلاسه کړی، د ادرس سپیلنګ وګورئ او د نوم لیکنې هڅه بیا ترسره کړئ.",
  "identities.messages.1040006": "د نوم لیکنې کوډ واستوئ",
  "identities.messages.1040007": "د پاسکي سره نوم لیکنه",
  "identities.messages.1040008": "بیرته",
  "identities.messages.1040009": "مهرباني وکړئ د خپل ځان تصدیق لپاره یو اعتبار غوره کړئ.",
  "identities.messages.1050001": "ستاسو بدلونونه ساتل شوي دي!",
  "identities.messages.1050002": "{provider} ونښلوئ",
  "identities.messages.1050003": "{provider} لرې کړئ",
  "identities.messages.1050004": "TOTP تصدیق کوونکي اپ لرې کړئ",
  "identities.messages.1050005": "د تصدیق کوونکي اپ QR کوډ",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "د بیک اپ بیارغونې کوډونه ښکاره کړئ",
  "identities.messages.1050008": "فعالول",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "دا ستاسو د بیک اپ بیارغونې کوډونه دي. مهرباني وکړئ دوی په خوندي ځای کې وساتئ!",
  "identities.messages.1050011": "د بیک اپ بیارغونې کوډونه تایید کړئ",
  "identities.messages.1050012": "امنیتي کیلي اضافه کړئ",
  "identities.messages.1050013": "د امنیتي کیلي نوم",
  "identities.messages.1050014": "سر په {used_at, date, long} کې کارول شوی و",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "دا میتود غیر فعال کړئ",
  "identities.messages.1050017": "د تصدیق کوونکي راز",
  "identities.messages.1050018": "امنیتي کیلي \"{display_name}\" لرې کړئ",
  "identities.messages.1050019": "پاسکي اضافه کړئ",
  "identities.messages.1050020": "پاسکي \"{display_name}\" لرې کړئ",
  "identities.messages.1060001": "تاسو په بریالیتوب سره خپل حساب بیرته ترلاسه کړ. مهرباني وکړئ په راتلونکو {privileged_session_expires_at_unix_until_minutes} دقیقو کې خپل پټنوم بدل کړئ یا د ننوتلو بله لاره (د بیلګې په توګه ټولنیز ننوتل) تنظیم کړئ.",
  "identities.messages.1060002": "تاسو ته چې چمتو کړې بریښنالیک ادرس ته یو بریښنالیک چې په کې د بیارغونې لینک وي واستول شوی دی. که تاسو بریښنالیک نه وو ترلاسه کړی، د ادرس سپیلنګ وګورئ او ډاډ ترلاسه کړئ چې هغه ادرس کاروئ چې تاسو ورسره نوم لیکنه کړې وه.",
  "identities.messages.1060003": "تاسو ته چې چمتو کړې بریښنالیک ادرس ته یو بریښنالیک چې په کې د بیارغونې کوډ وي واستول شوی دی. که تاسو بریښنالیک نه وو ترلاسه کړی، د ادرس سپیلنګ وګورئ او ډاډ ترلاسه کړئ چې هغه ادرس کاروئ چې تاسو ورسره نوم لیکنه کړې وه.",
  "identities.messages.1060004": "\"{masked_address}\" ته یوه بیارغونې کوډ واستول شوه. که تاسو دا نه وو ترلاسه کړې، د ادرس سپیلنګ وګورئ او ډاډ ترلاسه کړئ چې هغه ادرس کاروئ چې تاسو ورسره نوم لیکنه کړې وه.",
  "identities.messages.1060005": "خپل حساب ته د لاسرسي بیرته ترلاسه کولو لپاره خپله بیارغونې ادرس په بشپړه توګه چمتو کړئ.",
  "identities.messages.1060006": "تاسو غواړئ خپل حساب څنګه بیرته ترلاسه کړئ؟",
  "identities.messages.1060007": "بیرته",
  "identities.messages.1070001": "پټنوم",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "ساتل",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "سپارل",
  "identities.messages.1070006": "کوډ تصدیق کړئ",
  "identities.messages.1070007": "بریښنالیک",
  "identities.messages.1070008": "کوډ بیا واستوئ",
  "identities.messages.1070009": "دوام ورکړئ",
  "identities.messages.1070010": "د بیارغونې کوډ",
  "identities.messages.1070011": "تصدیقي کوډ",
  "identities.messages.1070012": "د نوم لیکنې کوډ",
  "identities.messages.1070013": "د ننوتلو کوډ",
  "identities.messages.1070014": "ننوتل او د اعتبار ونښلول",
  "identities.messages.1070015": "مهرباني وکړئ د دوام لپاره د کپچا چیلنج بشپړ کړئ.",
  "identities.messages.1070016": "د بیارغونې ادرس",
  "identities.messages.1070017": "د تلیفون شمیره",
  "identities.messages.1080001": "تاسو ته چې چمتو کړې بریښنالیک ادرس ته یو بریښنالیک چې په کې د تصدیق لینک وي واستول شوی دی. که تاسو بریښنالیک نه وو ترلاسه کړی، د ادرس سپیلنګ وګورئ او ډاډ ترلاسه کړئ چې هغه ادرس کاروئ چې تاسو ورسره نوم لیکنه کړې وه.",
  "identities.messages.1080002": "تاسو په بریالیتوب سره خپل بریښنالیک ادرس تصدیق کړ.",
  "identities.messages.1080003": "تاسو ته چې چمتو کړې بریښنالیک ادرس ته یو بریښنالیک چې په کې تصدیقي کوډ وي واستول شوی دی. که تاسو بریښنالیک نه وو ترلاسه کړی، د ادرس سپیلنګ وګورئ او ډاډ ترلاسه کړئ چې هغه ادرس کاروئ چې تاسو ورسره نوم لیکنه کړې وه.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "مهرباني وکړئ {property} دننه کړئ او بیا هڅه وکړئ.",
  "identities.messages.4000003": "اوږدوالی باید >= {min_length} وي، مګر {actual_length} ترلاسه شو",
  "identities.messages.4000004": "د \"{pattern}\" نمونې سره نه سمون خوري",
  "identities.messages.4000005": "پټنوم نشي کارول کیدای ځکه چې {reason}.",
  "identities.messages.4000006": "چمتو شوي اعتبارونه باطل دي، په خپل پټنوم یا کارن نوم، بریښنالیک ادرس، یا د تلیفون شمیره کې د سپیلنګ غلطیو وګورئ.",
  "identities.messages.4000007": "د ورته پیژندونکي (بریښنالیک، تلیفون، کارن نوم، ...) سره یو حساب لا دمخه شتون لري.",
  "identities.messages.4000008": "چمتو شوی تصدیقي کوډ باطل دی، مهرباني وکړئ بیا هڅه وکړئ.",
  "identities.messages.4000009": "هیڅ ننوتلو پیژندونکي ونه موندل شول. ایا تاسو هیر کړل چې دوی تنظیم کړئ؟ دا هم د سرور غلط تنظیم له امله کیدای شي.",
  "identities.messages.4000010": "حساب لا تر اوسه فعال نه دی. ایا تاسو خپل بریښنالیک ادرس تصدیق کول هیر کړل؟",
  "identities.messages.4000011": "تاسو هیڅ TOTP وسیله تنظیم کړې نه ده.",
  "identities.messages.4000012": "دا د بیک اپ بیارغونې کوډ لا دمخه کارول شوی دی.",
  "identities.messages.4000013": "تاسو هیڅ WebAuthn وسیله تنظیم کړې نه ده.",
  "identities.messages.4000014": "تاسو هیڅ د بیک اپ بیارغونې کوډونه تنظیم کړي نه دي.",
  "identities.messages.4000015": "دا حساب شتون نه لري یا هیڅ امنیتي کیلي تنظیم شوې نه ده.",
  "identities.messages.4000016": "د بیک اپ بیارغونې کوډ باطل دی.",
  "identities.messages.4000017": "اوږدوالی باید <= {max_length} وي، مګر {actual_length} ترلاسه شو",
  "identities.messages.4000018": "باید >= {minimum} وي مګر {actual} وموندل شو",
  "identities.messages.4000019": "باید > {minimum} وي مګر {actual} وموندل شو",
  "identities.messages.4000020": "باید <= {maximum} وي مګر {actual} وموندل شو",
  "identities.messages.4000021": "باید < {maximum} وي مګر {actual} وموندل شو",
  "identities.messages.4000022": "{actual} د {base} څو ګونی نه دی",
  "identities.messages.4000023": "اعظمي {max_items} توکي ته اجازه شتون لري، مګر {actual_items} توکي وموندل شول",
  "identities.messages.4000024": "لږترلږه {min_items} توکي ته اجازه شتون لري، مګر {actual_items} توکي وموندل شول",
  "identities.messages.4000025": "توکي په {index_a} او {index_b} کې برابر دي",
  "identities.messages.4000026": "{allowed_types_list} تمه کیده، مګر {actual_type} ترلاسه شو",
  "identities.messages.4000027": "د ورته پیژندونکي (بریښنالیک، تلیفون، کارن نوم، ...) سره یو حساب لا دمخه شتون لري. مهرباني وکړئ خپل موجود حساب ته ننوځئ ترڅو خپل ټولنیز پروفایل ونښلوئ.",
  "identities.messages.4000028": "تاسو د {credential_identifier_hint} سره د ننوتلو هڅه وکړه چې لا دمخه د بل حساب لخوا کارول کیږي. تاسو کولای شئ د {available_credential_types_list} په کارولو سره ننوځئ. تاسو کولای شئ د لاندې ټولنیزو ننوتلو چمتو کوونکو څخه یو وکاروئ: {available_oidc_providers_list}.",
  "identities.messages.4000029": "باید د ثابتې {expected} سره مساوي وي",
  "identities.messages.4000030": "ثابته ناکامه شوه",
  "identities.messages.4000031": "پټنوم نشي کارول کیدای ځکه چې دا د پیژندونکي سره ډیر ورته دی.",
  "identities.messages.4000032": "پټنوم باید لږ تر لږه {min_length} حروف اوږد وي، مګر {actual_length} ترلاسه شو.",
  "identities.messages.4000033": "پټنوم باید اعظمي {max_length} حروف اوږد وي، مګر {actual_length} ترلاسه شو.",
  "identities.messages.4000034": "پټنوم د معلوماتو له خرابیدو کې وموندل شو او نور باید ونه کارول شي.",
  "identities.messages.4000035": "دا حساب شتون نه لري یا د کوډ سره ننوتل تنظیم نه دي کړي.",
  "identities.messages.4000036": "چمتو شوي ځانګړتیاوې د دې جریان سره مخکې تړلي ځانګړتیاوو سره سمون نه خوري.",
  "identities.messages.4000037": "دا حساب شتون نه لري یا د ننوتلو میتود تنظیم شوې نه ده.",
  "identities.messages.4000038": "د کپچا تصدیق ناکام شو، مهرباني وکړئ بیا هڅه وکړئ.",
  "identities.messages.4010001": "د اړیکې وخت ختم شو. مهرباني وکړئ، بیا هڅه وکړئ.",
  "identities.messages.4010002": "تاسو ته د ننوتلو لپاره کومه ستراتیژي ونه موندل شوه. ایا تاسو فورم په سمه توګه ډک کړې وه؟",
  "identities.messages.4010003": "تاسو ته د نوم لیکنې لپاره کومه ستراتیژي ونه موندل شوه. ایا تاسو فورم په سمه توګه ډک کړې وه؟",
  "identities.messages.4010004": "ستاسو د ترتیباتو د تازه کولو لپاره کومه ستراتیژي ونه موندل شوه. ایا تاسو فورم په سمه توګه ډک کړې وه؟",
  "identities.messages.4010005": "ستاسو د حساب بیارغونې لپاره کومه ستراتیژي ونه موندل شوه. ایا تاسو فورم په سمه توګه ډک کړې وه؟",
  "identities.messages.4010006": "ستاسو د حساب تصدیق لپاره کومه ستراتیژي ونه موندل شوه. ایا تاسو فورم په سمه توګه ډک کړې وه؟",
  "identities.messages.4010007": "غوښتنه لا دمخه په بریالیتوب سره بشپړه شوې ده او نشي کیدای بیا هڅه شي.",
  "identities.messages.4010008": "د ننوتلو کوډ باطل دی یا لا دمخه کارول شوی دی. مهرباني وکړئ بیا هڅه وکړئ.",
  "identities.messages.4010009": "ونښل شوي اعتبارونه سمون نه خوري.",
  "identities.messages.4010010": "تاسو چې داخل کړې ادرس په اوسني حساب کې د پیژندل شوو ادرسونو سره سمون نه خوري.",
  "identities.messages.4040001": "د اړیکې وخت ختم شو. مهرباني وکړئ، بیا هڅه وکړئ.",
  "identities.messages.4040002": "غوښتنه لا دمخه په بریالیتوب سره بشپړه شوې ده او نشي کیدای بیا هڅه شي.",
  "identities.messages.4040003": "د نوم لیکنې کوډ باطل دی یا لا دمخه کارول شوی دی. مهرباني وکړئ بیا هڅه وکړئ.",
  "identities.messages.4050001": "د اړیکې وخت ختم شو. مهرباني وکړئ، بیا هڅه وکړئ.",
  "identities.messages.4060001": "غوښتنه لا دمخه په بریالیتوب سره بشپړه شوې ده او نشي کیدای بیا هڅه شي.",
  "identities.messages.4060002": "د بیارغونې جریان د ناکامۍ حالت ته ورسید او باید بیا هڅه شي.",
  "identities.messages.4060004": "د بیارغونې نښه باطله ده یا لا دمخه کارول شوې ده. مهرباني وکړئ جریان بیا هڅه کړئ.",
  "identities.messages.4060005": "د اړیکې وخت ختم شو. مهرباني وکړئ، بیا هڅه وکړئ.",
  "identities.messages.4060006": "د بیارغونې کوډ باطل دی یا لا دمخه کارول شوی دی. مهرباني وکړئ بیا هڅه وکړئ.",
  "identities.messages.4070001": "د تصدیق نښه باطله ده یا لا دمخه کارول شوې ده. مهرباني وکړئ جریان بیا هڅه کړئ.",
  "identities.messages.4070002": "غوښتنه لا دمخه په بریالیتوب سره بشپړه شوې ده او نشي کیدای بیا هڅه شي.",
  "identities.messages.4070003": "د تصدیق جریان د ناکامۍ حالت ته ورسید او باید بیا هڅه شي.",
  "identities.messages.4070005": "د اړیکې وخت ختم شو. مهرباني وکړئ، بیا هڅه وکړئ.",
  "identities.messages.4070006": "تصدیقي کوډ باطل دی یا لا دمخه کارول شوی دی. مهرباني وکړئ بیا هڅه وکړئ.",
  "identities.messages.5000001": "{reason}",
  "login.logout-button": "وتل",
  "login.registration-button": "نوم لیکنه",
  "login.registration-label": "حساب نه لرئ؟",
  "login.title": "ننوتل",
  "login.subtitle": "د {parts} سره ننوتل",
  "login.title-aal2": "د دوهم فاکتور تصدیق",
  "login.subtitle-aal2": "د خپل دوهم فاکتور تصدیق بشپړولو لپاره یوه لاره غوره کړئ",
  "login.code.subtitle": "یو تصدیقي کوډ به د بریښنالیک له لارې واستول شي",
  "login.webauthn.subtitle": "مهرباني وکړئ خپل WebAuthN وسیله چمتو کړئ",
  "login.totp.subtitle": "مهرباني وکړئ د خپل تصدیق کوونکي اپ لخوا رامنځته شوی کوډ دننه کړئ",
  "login.lookup_secret.subtitle": "مهرباني وکړئ د خپلو 8 رقمو بیک اپ بیارغونې کوډونو څخه یو دننه کړئ",
  "login.title-refresh": "بیا تصدیق",
  "login.subtitle-refresh": "خپل پیژندنه د {parts} سره تایید کړئ",
  "login.2fa.go-back": "څه کار نه کوي؟",
  "login.2fa.go-back.link": "بیرته ولاړشئ",
  "login.2fa.method.go-back": "بله طریقه غوره کړئ",
  "recovery.title": "خپل حساب بیرته ترلاسه کړئ",
  "recovery.subtitle": "د یو ځل لاسرسي کوډ ترلاسه کولو لپاره د خپل حساب سره تړلی پیژندونکی دننه کړئ",
  "registration.login-button": "ننوتل",
  "registration.login-label": "لا دمخه حساب لرئ؟",
  "registration.title": "د حساب نوم لیکنه",
  "registration.subtitle": "د {parts} سره نوم لیکنه",
  "settings.navigation-back-button": "بیرته",
  "settings.subtitle": "د خپل حساب ترتیبات تازه کړئ",
  "settings.title": "د حساب ترتیبات",
  "settings.password.title": "پټنوم بدلول",
  "settings.password.description": "خپل پټنوم بدل کړئ",
  "settings.profile.title": "د پروفایل ترتیبات",
  "settings.profile.description": "د خپل پروفایل معلومات تازه کړئ",
  "settings.webauthn.title": "د هارډویر نښانې اداره کړئ",
  "settings.webauthn.description": "د خپل هارډویر نښان ترتیبات اداره کړئ",
  "settings.messages.toast-title.success": "ترتیبات تازه شول",
  "settings.messages.toast-title.error": "ترتیبات تازه نشو کړای",
  "verification.title": "خپل حساب تصدیق کړئ",
  "verification.subtitle": "د هغې تصدیق لپاره د خپل حساب سره تړلی بریښنالیک ادرس دننه کړئ",
  "two-step.password.title": "پټنوم",
  "two-step.password.description": "د خپل حساب سره تړلی خپل پټنوم دننه کړئ",
  "two-step.code.title": "د بریښنالیک کوډ",
  "two-step.code.description": "یو تصدیقي کوډ به ستاسو بریښنالیک ته واستول شي",
  "two-step.webauthn.title": "امنیتي کیلي",
  "two-step.webauthn.description": "د تصدیق لپاره خپل امنیتي کیلي وکاروئ",
  "two-step.passkey.title": "پاسکي (سپارښتنه شوې)",
  "two-step.passkey.description": "د خپل وسیلې د ګوتو اثر یا مخ پیژندلو لپاره کاروئ",
  "two-step.passkey.description.error": "ستاسو د پاسکي کارولو لپاره اړین کتابتونونه بار نشو کیدای. مهرباني وکړئ وروسته بیا هڅه وکړئ.",
  "two-step.totp.title": "خپل تصدیق کوونکی اپ (TOTP) وکاروئ",
  "two-step.totp.description": "د خپل تصدیق کوونکي اپ څخه د 6 رقمو یو ځل کوډ وکاروئ",
  "two-step.lookup_secret.title": "د بیک اپ بیارغونې کوډ",
  "two-step.lookup_secret.description": "د تصدیق لپاره د خپلو 8 رقمو بیک اپ کوډونو څخه یو وکاروئ",
  "input.placeholder": "خپل {placeholder} دننه کړئ",
  "card.header.parts.oidc": "یو ټولنیز چمتو کوونکی",
  "card.header.parts.password.registration": "ستاسو {identifierLabel} او یو پټنوم",
  "card.header.parts.password.login": "ستاسو {identifierLabel} او پټنوم",
  "card.header.parts.code": "یو ځل کوډ",
  "card.header.parts.passkey": "یو پاسکي",
  "card.header.parts.webauthn": "یو امنیتي کیلي",
  "card.header.parts.totp": "ستاسو تصدیق کوونکی اپ",
  "card.header.parts.lookup_secret": "د بیک اپ بیارغونې کوډ",
  "card.header.parts.identifier-first": "ستاسو {identifierLabel}",
  "misc.or": "یا",
  "forms.label.forgot-password": "پټنوم هیر شوی؟",
  "forms.label.recover-account": "حساب بیرته ترلاسه کړئ",
  "settings.totp.title": "تصدیق کوونکی اپ",
  "settings.totp.description": "د خپل حساب امنیت ته وده ورکولو لپاره یو TOTP تصدیق کوونکی اپ خپل حساب ته اضافه کړئ. مشهور تصدیق کوونکي اپلیکیشنونه LastPass او Google Authenticator دي",
  "settings.totp.info.not-linked": "د فعالولو لپاره د خپل تصدیق کوونکي سره QR کوډ سکین کړئ او کوډ دننه کړئ.",
  "settings.totp.info.linked": "تاسو اوس مهال یو تصدیق کوونکی اپ نښلی دی.",
  "settings.lookup_secret.title": "د بیک اپ بیارغونې کوډونه (دوهم فاکتور)",
  "settings.lookup_secret.description": "د بیارغونې کوډونه د 2FA لپاره یو خوندي بیک اپ دي چې تاسو ته اجازه درکوي خپل حساب ته لاسرسی بیرته ترلاسه کړئ که چیرې تاسو خپله 2FA وسیله له لاسه ورکړئ.",
  "settings.oidc.title": "نښلي حسابونه",
  "settings.oidc.description": "د خپل حساب سره د ټولنیز ننوتلو چمتو کوونکی ونښلوئ.",
  "settings.oidc.info": "د دې چمتو کوونکو څخه نښلي حسابونه ستاسو حساب ته د ننوتلو لپاره کارول کیدای شي",
  "settings.webauthn.info": "د هارډویر نښانې د دوهم فاکتور تصدیق لپاره یا د پاسکي سره د لومړي فاکتور په توګه کارول کیږي",
  "settings.passkey.title": "پاسکي اداره کړئ",
  "settings.passkey.description": "د خپل پاسکي ترتیبات اداره کړئ",
  "settings.passkey.info": "د خپل پاسکي ترتیبات اداره کړئ",
  "card.footer.select-another-method": "بله طریقه غوره کړئ",
  "account-linking.title": "حساب ونښلوئ",
  "property.password": "پټنوم",
  "property.email": "بریښنالیک",
  "property.phone": "تلیفون",
  "property.username": "کارن نوم",
  "property.identifier": "پیژندونکی",
  "property.code": "کوډ",
  "property.recovery_address": "د بیارغونې ادرس",
  "consent.title": "{party} مجاز کړئ",
  "consent.subtitle": "یو درېیم اړخ اپلیکیشن غواړي ستاسو د حساب {identifier} سره تړلي معلوماتو ته لاسرسی ترلاسه کړي.",
  "consent.scope.openid.title": "پیژندنه",
  "consent.scope.openid.description": "اپلیکیشن ته اجازه ورکوي چې ستاسو پیژندنه تصدیق کړي. دا د تصدیق او د باور وړ ننوتلو تجربې لپاره اړین دی.",
  "consent.scope.offline_access.title": "آفلاین لاسرسی",
  "consent.scope.offline_access.description": "دې اپلیکیشن ته اجازه ورکوي چې تاسو ننوتلي وساتي حتی کله چې تاسو په فعاله توګه یې نه کاروئ.",
  "consent.scope.profile.title": "د پروفایل معلومات",
  "consent.scope.profile.description": "ستاسو د بنسټیز پروفایل توضیحاتو ته لاسرسي ورکوي، په شمول ستاسو کارن نوم، لومړی نوم، او وروستی نوم.",
  "consent.scope.email.title": "د بریښنالیک ادرس",
  "consent.scope.email.description": "ستاسو بریښنالیک ادرس او د هغې تصدیق حالت ترلاسه کړئ.",
  "consent.scope.address.title": "فزیکي ادرس",
  "consent.scope.address.description": "ستاسو پوستي ادرس ته لاسرسی.",
  "consent.scope.phone.title": "د تلیفون شمیره",
  "consent.scope.phone.description": "ستاسو د تلیفون شمیره او د هغې تصدیق حالت ترلاسه کړئ.",
  "error.title.what-happened": "څه پیښ شول؟",
  "error.title.what-can-i-do": "زه څه کولای شم؟",
  "error.instructions": "مهرباني وکړئ په څو دقیقو کې بیا هڅه وکړئ یا د ویب پاڼې چلوونکي سره اړیکه ونیسئ.",
  "error.footer.text": "کله چې د دې تېروتنې راپور ورکوئ، مهرباني وکړئ لاندې معلومات شامل کړئ:",
  "error.footer.copy": "کاپي کول",
  "error.action.go-back": "بیرته ولاړشئ",
  "identities.messages.4000039": "نوی پټنوم باید د زاړه پټنوم څخه توپیر ولري.",
  "identities.messages.4000040": "یو باوري بریښنالیک پته دننه کړئ",
  "identities.messages.4000041": "یو باوري تلیفون شمیره دننه کړئ",
  "captcha.error": "د امنیت تایید ناکام شو. مهرباني وکړئ وروسته بیا هڅه وکړئ. که ستونزه دوام ولري، له ملاتړ سره اړیکه ونیسئ.",
  "identities.messages.5000002": "هیڅ ډول تصدیق کولو طریقه شتون نلري. مهرباني وکړئ د سیستم اداره کوونکي سره اړیکه ونیسئ.",
  "identities.messages.4010011": "دا حساب غیر فعال شوی دی. مهرباني وکړئ د مرستې لپاره له مرستيالې څانګې سره اړیکه ونیسئ.",
  "identities.messages.1070018": "ایمیل یا د تلیفون نمبر",
  "identities.messages.1080004": "یو متن پیغام چې پکې د تایید کوډ شامل دی، ستاسو د هغه تیلیفون نمبر ته واستول شوی چې تاسو یې راکړئ. که تاسو متن پیغام ونه موندئ، د نمبر د لیکلو څرنګوالی وګورئ او ډاډ ترلاسه کړئ چې هغه نمبر وکاروئ چې تاسو یې ثبت کړی و.",
  "identities.messages.1080005": "ستاسو د ګرځنده تلیفون شمیره په بریالیتوب سره تایید شوه.",
  "identities.messages.5000003": "ستاسو سازمان ته د SSO تصدیق ته اړتیا لري، خو هیڅ SSO چمتو کونکي نه دي تنظیم شوي. مهرباني وکړئ د سیستم اداره کوونکي سره اړیکه ونیسئ.",
  "identities.messages.1010024": "د سخت افزاري کلید له لارې ننوتل وکړئ",
  "identities.messages.1010025": "یو کوډ ستاسو پته ته لیږل شوی. که چیرې تاسو نه دی ترلاسه کړی، مهرباني وکړئ بیا هڅه وکړئ.",
  "identities.messages.4000042": "ستاسو د \"ډیوایس آتین\" وسایل ندي تنظیم شوي.",
  "identities.messages.4000043": "د وړاندې شوي وب سایټ د ننوتلو (لاګن) کړنۍ سم نه ده، مهرباني وکړئ بیا هڅه وکړئ.",
  "identities.messages.4000044": "چمتو شوی DeviceAuthn لاسلیک باطل دی.",
  "identities.messages.4050002": "تاسو هره یو ځل یوازې یو پته بدلولی شئ. مهرباني وکړئ، هر پته جلا جلا نوي کړئ."
}
